/**
 * Public legal documents served by the backend outside the SPA
 * (see server/routes/legal.js). Absolute URLs so the pages open in an
 * external browser via openLink instead of resolving inside the mini app.
 */
export const OFERTA_URL = 'https://kiss-date.ru/legal/oferta';
export const PRIVACY_POLICY_URL = 'https://kiss-date.ru/legal/privacy';
